import {
  ApiPerformanceReviewInviteView,
  ApiPerformanceReviewRespondView,
} from "@/types/performance-review.types.ts";
import { ApiApprovalRequestFull } from "@/types/approvals/approval.types.ts";
import { ApiHiringPlanRequest } from "@/types/recruit/hiring-plan.types.ts";
import { ApiOfferRequest } from "@/types/recruit/offer.types.ts";
import { ApiFeedbackScoreCard } from "@/types/recruit/scorecard.types.ts";
import { ApiSurveyRespond } from "@/types/survey.types.ts";
import { ApiTask } from "@/types/task.types.ts";
import { ApiTimeOffLogFull } from "@/types/time-off/time-off.types.ts";
import { ApiEsignRequest } from "@/types/esign.types.ts";

export enum ApiTodayItemType {
  survey = "survey",
  time_off_log = "time_off_log",
  offer_request = "offer_request",
  performance_review = "performance_review",
  performance_review_invite = "performance_review_invite",
  feedback = "feedback",
  hiring_plan = "hiring_plan",
  task = "task",
  esign_request = "esign_request",
  grouped_performance_reviews = "grouped_performance_reviews",
  grouped_surveys = "grouped_surveys",
  approval_request = "approval_request",
}

export interface ApiTodayItem {
  type: ApiTodayItemType;
  survey: ApiSurveyRespond | null;
  time_off_log: ApiTimeOffLogFull | null;
  offer_request: ApiOfferRequest | null;
  performance_review: ApiPerformanceReviewRespondView | null;
  performance_review_invite: ApiPerformanceReviewInviteView | null;
  hiring_plan: ApiHiringPlanRequest | null;
  approval_request: ApiApprovalRequestFull | null;
  feedback: ApiFeedbackScoreCard | null;
  task: ApiTask | null;
  esign_request: ApiEsignRequest | null;
  subitems?: ApiTodayItem[];
}

export interface ApiTodayResult {
  items: ApiTodayItem[];
  overdue_items: ApiTodayItem[];
  unread_mentions_count: number;
  total_mentions_count: number;
}
